
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { VerifyDiscountDto } from './../../../core/api/models/verify-discount-dto';
import { DiscountPlace } from 'src/app/core/api/models';
import { DiscountService } from './../../../core/api/services/discount.service';

@Component({
    selector: 'app-verify-discount-input',
    templateUrl: './verify-discount-input.component.html',
    styleUrls: ['./verify-discount-input.component.scss'],
    standalone: false
})
export class VerifyDiscountInputComponent {

  discountCode?: string;
  @Input() discountPlace: DiscountPlace;
  @Input() id?: number;
  @Input() isAuthenticate?: boolean = true;

  @Output('result') output_result = new EventEmitter<VerifyDiscountResult>();


  result: VerifyDiscountDto = {};

  subscription: Subscription;
  loading: boolean = false;

  constructor(private discountService: DiscountService) { }

  onVerifyDiscountApi() {

    if (this.loading) return;

    this.loading = true;

    if (this.subscription)
      this.subscription.unsubscribe();
    
    this.subscription = this.discountService.discountVerifyDiscount({
      body: {
        discountCode: this.discountCode,
        discountPlace: this.discountPlace,
        id: this.id
      }
    })
      .pipe(
        finalize(() => { this.loading = false })
      )
      .subscribe((res) => {
        if (res.statusCode)
          this.result = { ...res.data };
        else {
          this.result = {};
          this.result.verifyDescription = res.validationErrors.join('\n');
        }
        this.emit();
      });

  }

  onRemoveDiscountVerified() {
    this.discountCode = "";
    this.result = {}
    this.emit();
  }

  onRemoveDiscountCode() {
    this.discountCode = "";
  }

  onChangeDiscountCode(discountCode) {
    this.discountCode = discountCode;
    if (!discountCode)
      this.result = {};
  }

  emit() {
    const result: VerifyDiscountResult = { ...this.result, discountCode: this.discountCode }
    this.output_result.emit(result);
  }

}

export interface VerifyDiscountResult extends VerifyDiscountDto {
  discountCode?: string;
}
